import Typography from '@mui/material/Typography'
import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import { SourceEntity } from 'types/SourceEntity'
import { isMFNLink } from './utils'
import { EditSourceDialog } from './AdminEditSourceDialog'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Stack from '@mui/material/Stack'
import { formatDateYYYYMMDDhhmm } from '../../../../packages/utils/numberFormatters'
import Button from '@mui/material/Button'
import { SourceUrl } from './AdminSourceUrl'
import { SourceForm } from '../../types/SourceForm'
import { TransactionType } from 'types/TransactionType'

function SourceTitleOrScrapeButton({ source }: { source: Pick<SourceEntity, 'title' | 'sourceUrl'> }) {
    if (source.title) {
        return <Typography>{source.title}</Typography>
    }

    if (!isMFNLink(source.sourceUrl)) {
        return <Typography>Ingen MFN-länk</Typography>
    }

    return <Typography>Titel saknas!</Typography>
}

export function SourceTableRow({
    onUpdate,
    onDelete,
    source,
    sources,
    duplicateSources = {},
    transactionType,
}: {
    onUpdate: (s: SourceForm) => boolean
    onDelete: (s: Pick<SourceForm, 'sourceUrl' | 'id'>) => void
    source: Extract<SourceForm, { sourceUrl: string }>
    sources: SourceForm[]
    duplicateSources: Record<string, boolean>
    transactionType: TransactionType
}) {
    const [openEditDialog, setOpenEditDialog] = useState(false)
    const handleDelete = (source: Pick<SourceEntity, 'sourceUrl'> & { id?: string }) => {
        onDelete(source)
    }

    return (
        <React.Fragment>
            {createPortal(
                <EditSourceDialog
                    open={openEditDialog}
                    setOpen={setOpenEditDialog}
                    onUpdate={onUpdate}
                    source={source}
                    sources={sources}
                    transactionType={transactionType}
                />,
                document.body,
            )}
            <TableRow key={source.sourceUrl}>
                <TableCell>
                    <Stack>
                        <SourceUrl source={source} />
                        {duplicateSources[source.sourceUrl] && (
                            <Typography variant='caption' sx={{ color: 'red' }}>
                                Registrerad tidigare
                            </Typography>
                        )}
                    </Stack>
                </TableCell>
                <TableCell>{source.internalComment}</TableCell>
                <TableCell>{source.sourceType}</TableCell>
                <TableCell>
                    <SourceTitleOrScrapeButton source={source} />
                </TableCell>
                <TableCell>{formatDateYYYYMMDDhhmm(source.publishedDate)}</TableCell>
                <TableCell>
                    <Stack spacing={1}>
                        <Button variant='outlined' onClick={() => setOpenEditDialog(true)}>
                            Redigera
                        </Button>
                        <Button variant='text' onClick={() => handleDelete(source)}>
                            [Ta&nbsp;bort]
                        </Button>
                    </Stack>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}
